import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const TopicListModel = types
  .model("TopicListModel", {
    topics: types.array(
      types.model("TopicList", {
        id: types.string,
        topicTitle: types.string,
      })
    ),
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FETCHING_TOPIC_LIST");
    },
    set(response) {
      const topics = response.data.response;
      applySnapshot(self, {
        topics,
      });
    },
  }));

export default TopicListModel;